module.exports = __webpack_public_path__ + "static/therooftop_01-aa7b489dcf03d1101ae7046d3c8e3ebe.png";